import type { PublicationCode } from '@/scopes/common/domain/models'
import { space } from '@sunwebgroup/ui-components'
import { Accordion } from '@sunwebgroup/ui-components/uds'
import { use } from 'react'
import styled from 'styled-components'
import { CatalogueDetailsContext } from '@/scopes/common/components/CatalogueDetailsContext'
import { CatalogueType } from '@/scopes/common/domain/enums/CatalogueType'
import { getCatalogueTypeByPublicationCode } from '@/scopes/common/domain/functions/catalogues'
import { useFeatureFlag } from '@/scopes/common/infrastructure/feature-flags'
import { DynamicFilters } from '@/scopes/search/search/pages/SearchPage/components/Filters/DynamicFilters'
import { SummerFilters } from '@/scopes/search/search/pages/SearchPage/components/Filters/SummerFilters'
import { WinterFilters } from './WinterFilters'

const AccordionRoot = styled(Accordion.Root)`
  > div {
    padding: 0;
  }

  div:not([class]) {
    [data-collapsible-root] {
      margin-top: ${space('primitives_space_8')};
    }
  }

  [data-collapsible-root] {
    margin-top: 0;
  }
`

export function Filters() {
  const { publicationCode } = use(CatalogueDetailsContext)
  const catalogType = getCatalogueTypeByPublicationCode(publicationCode as PublicationCode)
  const useDynamicFilters = useFeatureFlag('BAHAMAS_ENABLE_DYNAMIC_FILTERS')
  return (
    <AccordionRoot>
      {useDynamicFilters
        ? (
            <DynamicFilters catalogue={catalogType} publicationCode={publicationCode as PublicationCode} />
          )
        : (
            <>
              {catalogType === CatalogueType.Summer && <SummerFilters />}
              {catalogType === CatalogueType.Winter && <WinterFilters />}
            </>
          )}
    </AccordionRoot>
  )
}
